import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import SimpleReactValidator from 'simple-react-validator';
import { setUser } from '../../../../redux/actions/user.actions';
import btnIcon from '../../../../assets/images/arrow-circle.svg';
import webServices from '../../../../services/webServices';
import VerifyZelleIdPopup from '../../../admin/modals/VerifyZelleIdPopup';

const MakeMoneyPopup = ({
  modalStatus,
  handleClose,
  userDetails,
  handleOpenTerms
}) => {
  const dispatch = useDispatch();
  const { current } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    zellePhoneNo: userDetails?.phone,
    terms: false
  });
  const [selectedRadioOption, setSelectedRadioOption] = useState('yes');
  const handleRadioOptionChange = (evt) => setSelectedRadioOption(evt.target.value);
  const [isModelVisible, setIsModelVisible] = useState(false);
  const [mobileNoError, setMobileNoError] = useState('');

  const validatePhoneNumber = () => {
    if (selectedRadioOption === 'yes') return true; // not required

    if (!values.zellePhoneNo) return false; // required but empty

    return values.zellePhoneNo.length >= 11;
  };

  const [validator] = useState(new SimpleReactValidator());

  const forceUpdate = useState()[1].bind(null, {});

  const handleModalCloseEvent = () => setIsModelVisible(false);

  const finalSubmitForm = async () => {
    const resp = await webServices.updateUserDetails(userDetails?.id, values);
    if (resp?.success === true) {
      dispatch(setUser(resp?.data));
      handleClose(false);
    }
  };

  const submitForm = async () => {
    setMobileNoError('');
    if (!validatePhoneNumber()) {
      setMobileNoError('The mobile number field is required & must contain valid mobile number.');
    } else if (validator.allValid()) {
      setLoading(false);

      if (selectedRadioOption === 'no') {
        const result = await webServices.sendOtp({ email: current.email, isResend: 0 });
        if (result && result.success) {
          setIsModelVisible(true);
        }
      } else {
        await finalSubmitForm();
      }
    } else {
      validator.showMessages();
      forceUpdate();
    }
  };

  return (
    <>
      <Modal
        className="filter-model PlanStatusModel aff_login confirm_modal"
        show={modalStatus}
        onHide={handleClose}
        centered
        size=""
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="row">
              <div className="col-md-12">
                <h5 className="modal-title w-100">
                  Confirm how we should pay you!
                </h5>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Is this the phone number for your Zelle account?
          <div className="row w-100  input_field">
            <div className="col-md-12 col-lg-12 mb-4  custom_field">
              <div className="custom_input p-0">
                <PhoneInput
                  containerClass="custom_flag"
                  placeholder="Phone Number"
                  country="us"
                  value={values.zellePhoneNo}
                  onChange={(phone) =>
                    setValues({ ...values, zellePhoneNo: phone })
                  }
                  disabled={selectedRadioOption === 'yes'}
                />
              </div>
              {mobileNoError && (<div className='srv-validation-message'>{mobileNoError}</div>)}
            </div>

            <div className='col-md-12 col-lg-12 mb-4 mt-3'>
              <div className='customeRadio_Inner'>
              <input
                  type="radio"
                  value="yes"
                  id="yes"
                  name='radio-group'
                  checked={selectedRadioOption === 'yes'}
                  onChange={handleRadioOptionChange}
                />
                <label htmlFor="yes">YES, this is the phone number to my Zelle account</label>
              </div>

              <div className='customeRadio_Inner'>
              <input
                  type="radio"
                  value="no"
                  id="no"
                  name='radio-group'
                  checked={selectedRadioOption === 'no'}
                  onChange={handleRadioOptionChange}
                />
                <label htmlFor="no">NO, this is NOT the phone number to my Zelle account</label>
              </div>
            </div>

            <div className="col-md-12 col-lg-12 form-group modalLogin ">
              <input
                type="checkbox"
                name="terms"
                id="terms"
                checked={values.terms || false}
                onChange={(e) =>
                  setValues({ ...values, terms: e.target.checked })
                }
              />{' '}
              <label className=" flex item-center" htmlFor="terms">
               <span className='pl-2 pr-2'> I have read & agree to</span>
              </label>
              <span
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                aria-hidden="true"
                onClick={handleOpenTerms}
              >
                terms of service
              </span>

            </div>

            <div className="col-md-12 col-lg-12">
            {validator.message('terms', values.terms, 'accepted', {
                messages: { accepted: 'You must accept the terms to proceed' }
              })}
            </div>
          </div>
          <div className="col-md-12 col-lg-12 pb-4 mb-3 mt-3  marb7 text-right">
            <button
              className={`new_next_btn ${loading ? 'hks-btn-disable' : ''}`}
              onClick={submitForm}
              onKeyDown={(event) => event.key === 'Enter' && submitForm()}
              type="button"
              tabIndex="0"
              disabled={loading || false}
            >
              <img src={btnIcon} className="img-fluid" alt="Lovrican Logo" />
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <VerifyZelleIdPopup isModalVisible={isModelVisible} handelClose={handleModalCloseEvent} emailVerifiedHandler={finalSubmitForm} user={current} />
    </>
  );
};
export default MakeMoneyPopup;
